import React, { useState, useRef } from "react";
import { NavLink } from "react-router-dom";

const tealBorder = "#06d1c6";
const tealBg = "#06d1c6";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
  padding: "24px",
  marginBottom: "20px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  border: `1px solid ${tealBorder}`,
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const sectionTitleStyle = {
  fontWeight: 700,
  color: "#334155",
  fontSize: "16px",
  marginBottom: "16px",
};

const DESC_MAX = 250;

const defaultScheme = () => ({ search: "", currentAmount: "" });

const CAMS_WEBSITE_URL = "https://www.camsonline.com";

export default function NewClientPortfolio() {
  const [name, setName] = useState("");
  const [benchmark, setBenchmark] = useState("");
  const [description, setDescription] = useState("");
  const [filePassword, setFilePassword] = useState("");
  const [schemes, setSchemes] = useState([defaultScheme()]);
  const [includeFactsheet, setIncludeFactsheet] = useState(false);
  const fileInputRef = useRef(null);

  const descLeft = Math.max(0, DESC_MAX - description.length);

  const addScheme = () => {
    setSchemes((prev) => [...prev, defaultScheme()]);
  };

  const removeScheme = (index) => {
    if (schemes.length <= 1) return;
    setSchemes((prev) => prev.filter((_, i) => i !== index));
  };

  const updateScheme = (index, field, value) => {
    setSchemes((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );
  };

  const handleUploadCAS = (e) => {
    e.preventDefault();
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      // TODO: upload CAS file with filePassword
      console.log({ file, filePassword });
    }
    e.target.value = "";
  };

  const handleSave = (e) => {
    e.preventDefault();
    // TODO: API submit
    console.log({ name, benchmark, description, schemes, includeFactsheet });
  };

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Back link */}
          <div className="mb-3">
            <NavLink
              to="/admin/portfolio/model"
              className="d-inline-flex align-items-center gap-2 text-decoration-none"
              style={{ color: "#475569", fontSize: "14px" }}
            >
              <i className="fa fa-arrow-left" />
              Back
            </NavLink>
          </div>

          <div style={{ ...cardStyle, maxWidth: 800 }}>
            <form onSubmit={handleSave}>
              {/* Model Details */}
              <div className="mb-4">
                <h2 style={sectionTitleStyle}>Model Details</h2>
                <div className="row g-3 mb-3">
                  <div className="col-12 col-md-6">
                    <input
                      type="text"
                      placeholder="Client Portfolio Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      style={inputStyle}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <select
                      value={benchmark}
                      onChange={(e) => setBenchmark(e.target.value)}
                      style={inputStyle}
                    >
                      <option value="">Benchmark</option>
                      <option value="nifty50">Nifty 50</option>
                      <option value="sensex">Sensex</option>
                      <option value="custom">Custom</option>
                    </select>
                  </div>
                </div>
                <div>
                  <textarea
                    placeholder="Client Portfolio Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value.slice(0, DESC_MAX))}
                    rows={4}
                    maxLength={DESC_MAX}
                    style={{ ...inputStyle, resize: "vertical" }}
                  />
                  <div className="small mt-1 text-end" style={{ color: "#64748b" }}>
                    {descLeft} characters left
                  </div>
                </div>
              </div>

              {/* CAS Import */}
              <div className="mb-4">
                <p className="mb-2" style={{ color: "#475569", fontSize: "14px" }}>
                  You can also Import Schemes from CAS Summary. Order CAS Summary from{" "}
                  <a
                    href={CAMS_WEBSITE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#2563eb", textDecoration: "underline" }}
                  >
                    CAMS Website
                  </a>
                  .
                </p>
                <div className="d-flex flex-wrap align-items-end gap-2">
                  <div>
                    <label className="form-label small text-secondary mb-1 d-block">File Password</label>
                    <input
                      type="password"
                      placeholder="Password"
                    value={filePassword}
                      onChange={(e) => setFilePassword(e.target.value)}
                      style={{ ...inputStyle, maxWidth: 220 }}
                    />
                  </div>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,.xls,.xlsx,.csv"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <button
                    type="button"
                    onClick={handleUploadCAS}
                    style={{
                      background: tealBg,
                      color: "#fff",
                      border: "none",
                      padding: "10px 20px",
                      borderRadius: "6px",
                      fontWeight: 600,
                      fontSize: "14px",
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i className="fa fa-upload" />
                    Upload CAS
                  </button>
                </div>
              </div>

              {/* Model Schemes */}
              <div className="mb-4">
                <h2 style={sectionTitleStyle}>Model Schemes</h2>
                {schemes.map((row, index) => (
                  <div key={index} className="d-flex flex-wrap align-items-center gap-2 mb-2">
                    <input
                      type="text"
                      placeholder="Search Scheme"
                      value={row.search}
                      onChange={(e) => updateScheme(index, "search", e.target.value)}
                      style={{ ...inputStyle, flex: "1 1 200px", minWidth: 0 }}
                    />
                    <div className="d-flex align-items-center" style={{ flex: "1 1 180px", minWidth: 0 }}>
                      <input
                        type="text"
                        placeholder="Current Amount"
                        value={row.currentAmount}
                        onChange={(e) => updateScheme(index, "currentAmount", e.target.value)}
                        style={{ ...inputStyle }}
                      />
                      <button
                        type="button"
                        onClick={() => removeScheme(index)}
                        className="btn btn-link p-2 ms-1 text-secondary"
                        style={{ minWidth: 36 }}
                        aria-label="Remove scheme"
                        title="Remove"
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={addScheme}
                  className="btn btn-link p-0 border-0 shadow-none"
                  style={{ color: tealBorder, fontWeight: 600, fontSize: "14px" }}
                >
                  Add another scheme
                </button>
                <div className="mt-3">
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={includeFactsheet}
                      onChange={(e) => setIncludeFactsheet(e.target.checked)}
                      style={{ accentColor: tealBorder }}
                    />
                    Include Factsheet
                  </label>
                </div>
              </div>

              {/* Save */}
              <div>
                <button
                  type="submit"
                  style={{
                    background: tealBg,
                    color: "#fff",
                    border: "none",
                    padding: "10px 28px",
                    borderRadius: "6px",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
